export const CARE_TEAM_ROLE_MAP = new Map(
  Object.entries({
    429577009: 'Patient advocate',
    116154003: 'Patient',
    133932002: 'Caregiver',
    223366009: 'Healthcare professional',
    1421009: 'Specialised surgeon',
    3430008: 'Radiation therapist',
    3842006: 'Chiropractor',
    4162009: 'Dental assistant',
    5275007: 'Auxiliary nurse',
    6816002: 'Specialised nurse',
    6868009: 'Hospital administrator',
    8724009: 'Plastic surgeon',
    11661002: 'Neuropathologist',
    11911009: 'Nephrologist',
    11935004: 'Obstetrician',
    13580004: 'School dental assistant',
    14698002: 'Medical microbiologist',
    17561000: 'Cardiologist',
    18803008: 'Dermatologist',
    18850004: 'Laboratory hematologist',
    19244007: 'Gerodontist',
    20145008: 'Removable prosthodontist',
    21365001: 'Specialised dentist',
    21450003: 'Neuropsychiatrist',
    22515006: 'Medical assistant',
    22731001: 'Orthopedic surgeon',
    22983004: 'Thoracic surgeon',
    23278007: 'Community health physician',
    24430003: 'Physical medicine specialist',
    24590004: 'Urologist',
    25961008: 'Electroencephalography specialist',
    26042002: 'Dental hygienist',
    26369006: 'Public health nurse',
    28229004: 'Optometrist',
    28411006: 'Neonatologist',
    28544002: 'Medical biochemist',
    36682004: 'Physiotherapist',
    37154003: 'Periodontist',
    37504001: 'Orthodontist',
    39677007: 'Internal medicine specialist',
    40127002: 'Dietitian (general)',
    40204001: 'Hematologist',
    40570005: 'Interpreter',
    41672002: 'Respiratory disease specialist',
    41904004: 'Medical X-ray technician',
    43702002: 'Occupational health nurse',
    44652006: 'Pharmaceutical assistant',
    45440000: 'Rheumatologist',
    45544007: 'Neurosurgeon',
    45956004: 'Sanitarian',
    46255001: 'Pharmacist',
    48740002: 'Philologist',
    49203003: 'Dispensing optician',
    49993003: 'Oral surgeon',
    50149000: 'Endodontist',
    54503009: 'Faith healer',
    56397003: 'Neurologist',
    56466003: 'Public health physician',
    56542007: 'Medical record administrator',
    56545009: 'Cardiovascular surgeon',
    57654006: 'Fixed prosthodontist',
    59058001: 'General physician',
    59169001: 'Orthopaedic technician',
    59317003: 'Dental prosthesis maker and repairer',
    59944000: 'Psychologist',
    60008001: 'Public health nutritionist',
    61207006: 'Medical pathologist',
    61246008: 'Laboratory medicine specialist',
    61345009: 'Otorhinolaryngologist',
    61894003: 'Endocrinologist',
    62247001: 'Family medicine specialist',
    63098009: 'Clinical immunologist',
    66476003: 'Oral pathologist',
    66862007: 'Radiologist',
    68867008: 'Public health dentist',
    68950000: 'Prosthodontist',
    69280009: 'Specialised physician',
    71838004: 'Gastroenterologist',
    73265009: 'Nursing aid',
    75271001: 'Professional midwife',
    76166008: 'Practical aid (pharmacy)',
    76231001: 'Osteopath',
    76899008: 'Infectious disease specialist',
    78703002: 'General surgeon',
    78729002: 'Diagnostic radiologist',
    79898004: 'Auxiliary midwife',
    80409005: 'Translator',
    80546007: 'Occupational therapist',
    80584001: 'Psychiatrist',
    80933006: 'Nuclear medicine specialist',
    81464008: 'Clinical pathologist',
    82296001: 'Pediatrician',
    83273008: 'Anatomic pathologist',
    83685006: 'Gynecologist',
    85733003: 'General pathologist',
    88189002: 'Anesthesiologist',
    90201008: 'Pedodontist',
    90655003: 'Geriatrics specialist',
    106289002: 'Dentist',
    106292003: 'Professional nurse',
    106293008: 'Nursing personnel',
    106294002: 'Midwifery personnel',
    106296000: 'Physiotherapist AND/OR occupational therapist',
    106330007: 'Philologist, translator AND/OR interpreter',
    158965000: 'Medical practitioner',
    158966004: 'Medical administrator - national',
    158967008: 'Consultant physician',
    158968003: 'Consultant surgeon',
    158969006: 'Consultant gynecology and obstetrics',
    158971006: 'Hospital registrar',
    158972004: 'House officer',
    158973009: 'Occupational physician',
    158974003: 'Clinical medical officer',
    158975002: 'Medical practitioner - teaching',
    158977005: 'Dental administrator',
    158978000: 'Dental consultant',
    158979008: 'Dental general practitioner',
    158980006: 'Dental practitioner - teaching',
    158983008: 'Nurse administrator - national',
    158984002: 'Nursing officer - region',
    158985001: 'Nursing officer - district',
    158986000: 'Nursing administrator - professional body',
    158987009: 'Nursing officer - division',
    158988004: 'Nurse education director',
    158989007: 'Occupational health nursing officer',
    158990003: 'Nursing officer',
    158992006: 'Midwifery sister',
    158993001: 'Nursing sister (theatre)',
    158994007: 'Staff nurse',
    158995008: 'Staff midwife',
    158996009: 'State enrolled nurse',
    158997000: 'District nurse',
    158998005: 'Private nurse',
    158999002: 'Community midwife',
    159001001: 'Clinic nurse',
    159002008: 'Practice nurse',
    159003003: 'School nurse',
    159004009: 'Nurse - teaching',
    159005005: 'Student nurse',
    159006006: 'Dental nurse',
    159007002: 'Community pediatric nurse',
    159010009: 'Hospital pharmacist',
    159011008: 'Retail pharmacist',
    159012001: 'Industrial pharmacist',
    159014000: 'Trainee pharmacist',
    159016003: 'Medical radiographer',
    159017007: 'Diagnostic radiographer',
    159018002: 'Therapeutic radiographer',
    159019005: 'Trainee radiographer',
    159021000: 'Ophthalmic optician',
    159022007: 'Trainee optician',
    159025009: 'Remedial gymnast',
    159026005: 'Speech and language therapist',
    159027001: 'Orthoptist',
    159028006: 'Trainee remedial therapist',
    159033005: 'Dietician',
    159034004: 'Podiatrist',
    159035003: 'Dental auxiliary',
    159036002: 'ECG technician',
    159037006: 'EEG technician',
    159038001: 'Artificial limb fitter',
    159039009: 'AT - Audiology technician',
    159040006: 'Pharmacy technician',
    159041005: 'Trainee medical technician',
    159141008: 'Geneticist',
    159972006: 'Surgical corset fitter',
    160008000: 'Dental technician',
    224529009: 'Clinical assistant',
    224530004: 'Senior registrar',
    224531000: 'Registrar',
    224532007: 'Senior house officer',
    224533002: 'MO - Medical officer',
    224534008: 'Health visitors, nurses and midwives',
    224535009: 'Registered nurse',
    224536005: 'Midwifery tutor',
    224537001: 'Accident and Emergency nurse (occupation)',
    224538006: 'Triage nurse',
    224540001: 'Community nurse',
    224541002: 'Nursing continence advisor',
    224542009: 'Coronary care nurse',
    224543004: 'Diabetic nurse',
    224544005: 'Family planning nurse',
    224545006: 'Care of the elderly nurse',
    224546007: 'ICN - Infection control nurse',
    224547003: 'Intensive therapy nurse',
    224548008: 'Learning disabilities nurse',
    224549000: 'Neonatal nurse',
    224550000: 'Neurology nurse',
    224551001: 'Industrial nurse',
    224552008: 'Oncology nurse',
    224554009: 'Marie Curie nurse',
    224555005: 'Pain control nurse',
    224556006: 'Palliative care nurse',
    224557002: 'Chemotherapy nurse',
    224558007: 'Radiotherapy nurse',
    224559004: 'Recovery nurse',
    224560009: 'Stomatherapist',
    224562001: 'Paediatric nurse',
    224563006: 'Psychiatric nurse',
    224564000: 'Community mental health nurse',
    224565004: 'Renal nurse',
    224566003: 'Haemodialysis nurse',
    224567007: 'Wound care nurse',
    224569005: 'Nurse grade',
    224570006: 'Clinical nurse specialist',
    224571005: 'Nurse practitioner',
    224572003: 'Nursing sister',
    224573008: 'CN - Charge nurse',
    224574002: 'Ward manager',
    224575001: 'Nursing team leader',
    224576000: 'Nursing assistant',
    224577009: 'HCA - Healthcare assistant',
    224578004: 'Nursery nurse',
    224579007: 'Healthcare service manager',
    224580005: 'Occupational health service manager',
    224581009: 'Community nurse manager',
    224583007: 'Behavior therapist',
    224584001: 'Behaviour therapy assistant',
    224585000: 'Drama therapist',
    224586004: 'Domiciliary occupational therapist',
    224587008: 'Occupational therapy helper',
    224588003: 'Psychotherapist',
    224589006: 'Community-based physiotherapist',
    224590002: 'Play therapist',
    224591003: 'Play specialist',
    224592005: 'Play leader',
    224593000: 'Community-based speech and language therapist',
    224594006: 'Speech and language assistant',
    224595007: 'Professional counsellor',
    224596008: 'Marriage guidance counsellor',
    224597004: 'Trained nurse counsellor',
    224598009: 'Trained social worker counsellor',
    224599001: 'Trained personnel counsellor',
    224600003: 'Psychoanalyst',
    224601004: 'Assistant psychologist',
    224602006: 'Community-based podiatrist',
    224603001: 'Foot care worker',
    224604007: 'Audiometrician',
    224606009: 'Technical healthcare occupation',
    224607000: 'Occupational therapy technical instructor',
    224608005: 'Administrative healthcare staff',
    224609002: 'Complementary health worker',
    224610007: 'Supporting services personnel',
    224614003: 'Research associate',
    224615002: 'Research nurse',
    224620002: 'Human aid to communication',
    224621003: 'Palantypist',
    224622005: 'Note taker',
    224623000: 'Cuer',
    224624006: 'Lipspeaker',
    224625007: 'Interpreter for British sign language',
    224626008: 'Interpreter for Signs supporting English',
    224936003: 'General practitioner locum',
    225726006: 'Lactation consultant',
    225727002: 'Midwife counsellor',
    265937000: 'Nursing occupation (occupation)',
    265939002: 'Medical/dental technicians',
    283875005: "Parkinson's disease nurse",
    302211009: 'Specialist registrar',
    303124005: 'Member of mental health review tribunal',
    303129000: 'Hospital manager',
    303133007: 'Responsible medical officer',
    303134001: 'Independent doctor',
    304291006: 'Bereavement counsellor',
    304292004: 'Surgeon',
    307988006: 'Medical technician',
    308002005: 'Remedial therapist',
    309294001: 'Accident and emergency doctor',
    309295000: 'Clinical oncologist',
    309296004: 'Family planning doctor',
    309322005: 'Associate general practitioner',
    309323000: 'Partner of general practitioner',
    309324006: 'Assistant GP',
    309326008: 'Deputizing general practitioner',
    309327004: 'General practitioner registrar',
    309328009: 'Ambulatory pediatrician',
    309329001: 'Community paediatrician',
    309330006: 'Pediatric cardiologist',
    309331005: 'Pediatric endocrinologist',
    309332003: 'Paediatric gastroenterologist',
    309333008: 'Pediatric nephrologist',
    309334002: 'Paediatric neurologist',
    309335001: 'Pediatric rheumatologist',
    309336000: 'Paediatric oncologist',
    309337009: 'Pain management specialist',
    309338004: 'Intensive care specialist',
    309339007: 'Adult intensive care specialist',
    309340009: 'Pediatric intensive care specialist',
    309341008: 'Blood transfusion doctor',
    309342001: 'Histopathologist',
    309343006: 'Physician',
    309345004: 'Chest physician',
    309346003: 'Thoracic physician',
    309347007: 'Clinical hematologist',
    309348002: 'Clinical neurophysiologist',
    309349005: 'Clinical physiologist',
    309350005: 'Diabetologist',
    309351009: 'Andrologist',
    309352002: 'Neuroendocrinologist',
    309353007: 'Reproductive endocrinologist',
    309354001: 'Thyroidologist',
    309355000: 'Clinical geneticist',
    309356004: 'Clinical cytogeneticist',
    309357008: 'Clinical molecular geneticist',
    309358003: 'Genitourinary medicine physician',
    309359006: 'Palliative care physician',
    309360001: 'Rehabilitation physician',
    309361002: 'Child and adolescent psychiatrist',
    309362009: 'Forensic psychiatrist',
    309363004: 'Liaison psychiatrist',
    309364005: 'Psychogeriatrician',
    309366007: 'Rehabilitation psychiatrist',
    309367003: 'Obstetrician and gynecologist',
    309368008: 'Breast surgeon',
    309369000: 'Cardiothoracic surgeon',
    309371000: 'Cardiac surgeon',
    309372007: 'Ear, nose and throat surgeon',
    309373002: 'Endocrine surgeon',
    309374008: 'Thyroid surgeon',
    309375009: 'Pituitary surgeon',
    309376005: 'Gastrointestinal surgeon',
    309377001: 'General gastrointestinal surgeon',
    309378006: 'Upper gastrointestinal surgeon',
    309379003: 'Colorectal surgeon',
    309380000: 'Hand surgeon',
    309381001: 'Hepatobiliary surgeon',
    309382008: 'Ophthalmic surgeon',
    309383003: 'Pediatric surgeon',
    309384009: 'Pancreatic surgeon',
    309385005: 'Transplant surgeon',
    309386006: 'Trauma surgeon',
    309388007: 'Vascular surgeon',
    309389004: 'Medical practitioner grade',
    309390008: 'Hospital consultant',
    309391007: 'Visiting specialist registrar',
    309392000: 'Research registrar',
    309393005: 'General practitioner grade',
    309394004: 'General practitioner principal',
    309395003: 'Hospital specialist',
    309396002: 'Associate specialist',
    309397006: 'Research fellow',
    309398001: 'Profession allied to medicine',
    309399009: 'Hospital dietitian',
    309400002: 'Domiciliary physiotherapist',
    309401003: 'GP-based physiotherapist',
    309402005: 'Hospital-based physiotherapist',
    309403000: 'Private physiotherapist',
    309404006: 'Physiotherapy helper',
    309409001: 'Hospital-based speech and language therapist',
    309410006: 'Arts therapist',
    309411005: 'Dance therapist',
    309412003: 'Music therapist',
    309413008: 'Renal dietitian',
    309414002: 'Liver dietitian',
    309415001: 'Oncology dietitian',
    309416000: 'Pediatric dietitian',
    309417009: 'Diabetes dietitian',
    309418004: 'Audiologist',
    309419007: 'Hearing therapist',
    309420001: 'Audiological scientist',
    309421002: 'Hearing aid dispenser',
    309422009: 'Community-based occupational therapist',
    309423004: 'Hospital occupational therapist',
    309427003: 'Social services occupational therapist',
    309428008: 'Orthotist',
    309429000: 'Surgical fitter',
    309434001: 'Hospital-based podiatrist',
    309435000: 'Podiatry assistant',
    309436004: 'Lymphedema nurse',
    309437008: 'Community learning disabilities nurse',
    309439006: 'Clinical nurse teacher',
    309440008: 'Community practice nurse teacher',
    309441007: 'Nurse tutor',
    309442000: 'Nurse teacher practitioner',
    309443005: 'Nurse lecturer practitioner',
    309444004: 'Outreach nurse',
    309445003: 'Anesthetic nurse',
    309446002: 'Nurse manager',
    309450009: 'Nurse administrator',
    309452001: 'Midwifery grade',
    309453006: 'Registered midwife',
    309454000: 'Student midwife',
    309455004: 'Parentcraft sister',
    309459005: 'Healthcare professional grade',
    309460000: 'Restorative dentist',
    310170009: 'Paediatric audiologist',
    310171008: 'Immunopathologist',
    310172001: 'Audiological physician',
    310173006: 'Clinical pharmacologist',
    310174000: 'Private doctor',
    310175004: 'Agency nurse',
    310176003: 'Behavioral therapist nurse',
    310177007: 'Cardiac rehabilitation nurse',
    310178002: 'Genitourinary nurse',
    310179005: 'Rheumatology nurse specialist',
    310180008: 'Continence nurse',
    310181007: 'Contact tracing nurse',
    310182000: 'General nurse',
    310184004: 'Liaison nurse',
    310185003: 'Diabetic liaison nurse',
    310186002: 'Nurse psychotherapist',
    310187006: 'Company nurse',
    310188001: 'Hospital midwife',
    310189009: 'Genetic counsellor',
    310190000: 'Mental health counsellor',
    310191001: 'Clinical psychologist',
    310192008: 'Educational psychologist',
    310193003: 'Coroner',
    310194009: 'Appliance officer',
    310512001: 'Medical oncologist',
    311441001: 'School medical officer',
    312485001: 'Integrated midwife',
    372102007: 'RN First Assist',
    387619007: 'Optician (occupation)',
    394572006: 'Medical secretary (occupation)',
    394618009: 'Hospital nurse (occupation)',
    397897005: 'Paramedic (occupation)',
    397903001: 'Staff grade obstetrician (occupation)',
    397908005: 'Staff grade practitioner (occupation)',
    398130009: 'Medical student (occupation)',
    398238009: 'Acting obstetric registrar (occupation)',
    404940000: 'Physiotherapist technical instructor (occupation)',
    405277009: 'Resident physician (occupation)',
    405278004: 'Certified registered nurse anesthetist (occupation)',
    405279007: 'Attending physician (occupation)',
    405623001: 'Assigned practitioner (occupation)',
    405684005: 'Professional initiating surgical case',
    405685006: 'Professional providing staff relief during surgical procedure',
    408798009: 'Consultant pediatrician (occupation)',
    408799001: 'Consultant neonatologist (occupation)',
    409974004: 'Health educator (occupation)',
    409975003: 'Certified health education specialist (occupation)',
    413854007: 'Circulating nurse (occupation)',
    415075003: 'Perioperative nurse (occupation)',
    415506007: 'Scrub nurse (occupation)',
    416160000: 'Fellow of American Academy of Osteopathy (occupation)',
    420409002: 'Oculoplastic surgeon (occupation)',
    420678001: 'Retinal surgeon (occupation)',
    421841007: 'Admitting physician (occupation)',
    422140007: 'Medical ophthalmologist (occupation)',
    422234006: 'Ophthalmologist (occupation)',
    432100008: 'Health coach (occupation)',
    442867008: 'Respiratory therapist (occupation)',
    443090005: 'Podiatric surgeon (occupation)',
    444912007: 'Hypnotherapist (occupation)',
    445313000: 'Asthma nurse specialist (occupation)',
    445451001: 'Nurse case manager (occupation)',
    446050000: 'Primary care physician (occupation)',
    446701002: 'Addiction medicine specialist (occupation)',
    449161006: 'Physician assistant (occupation)',
    471302004: 'Government midwife (occupation)',
    720503005: 'Sleep medicine specialist (occupation)',
    721936008: 'Occupation medicine specialist (occupation)',
    721937004: 'Preventive medicine specialist (occupation)',
    721938009: 'Tropical medicine specialist (occupation)',
    721939001: 'Vascular medicine specialist',
    721940004: 'Legal medicine specialist (occupation)',
    721941000: 'Health psychologist (occupation)',
    721942007: 'Cardiovascular perfusionist (occupation)',
    721943002: 'Clinical immunology and allergy specialist (occupation)',
    734293001: 'Clinical pharmacist (occupation)',
    734294007: 'Pharmacist prescriber (occupation)',
    763292005: 'Radiation oncologist (occupation)',
    768730001: 'Home health aide (occupation)',
    768731002: 'Home helper',
    768732009: 'School health educator',
    768819009: 'Medically responsible investigator (occupation)',
    768825008: 'Doula (occupation)',
    768826009: 'Crisis counsellor',
    768827000: 'Nutritionist',
    768828005: 'Epidemiologist',
    768829002: 'Community dietician (occupation)',
    768832004: 'Case manager (occupation)',
    768833009: 'Discharging physician',
    768834003: 'Disease manager (occupation)',
    768836001: 'Patient navigator',
    768837005: 'Hospitalist (occupation)',
    768839008: 'Consultant (occupation)',
    789543004: 'Ultrasonographer',
    840583002: 'Allied health assistant (occupation)',
    840584008: 'Allied health student',
    878785002: 'Clinical respiratory physiologist',
    878786001: 'Operating room technician (occupation)',
    878787005: 'Anesthesia technician',
    897187007: 'Sexual assault nurse examiner (occupation)',
    1172950003: 'Massage therapist (occupation)',
    1186716007: 'Intellectual disability psychiatrist (occupation)',
    1186914001: 'Intellectual disability nurse (occupation)',
    1251537007: 'Sport medicine specialist (occupation)',
    1251542004: 'Medical coder (occupation)',
    1251548000: 'Neuroradiologist (occupation)',
    1254982001: 'Medical surgical nurse',
    1254983006: 'Chronic care nurse (occupation)',
    1254984000: 'Rehabilitation nurse (occupation)',
    1255370008: 'Specialist in naturopathy',
    1255371007: 'Specialist in homeopathy (occupation)',
    1255372000: 'Phytotherapist',
    1255373005: 'Specialist in traditional Chinese medicine (occupation)',
    1255374004: 'Clinical nutritionist (occupation)',
    1255514008: 'Regulatory affairs pharmacist (occupation)',
    1255515009: 'Pharmacogenomics pharmacist (occupation)',
    1255516005: 'Clinical analysis pharmacist (occupation)',
    1255517001: 'Intern in healthcare (occupation)',
    1255518006: 'Organisational and social psychologist',
    1255519003: 'Cardiopulmonary technician (occupation)',
    1255719001: 'Neurophysiology technician',
    1256114007: 'Nuclear medicine technologist',
    1259214004: 'Immunohemotherapy specialist (occupation)',
    1259964002: 'Oral medicine specialist (occupation)',
    3981000175106: 'Nurse complex case manager',
    9371000175105: 'Adolescent medicine specialist',
    25941000087102:
      'Adult gerontology primary care nurse practitioner (occupation)',
    26031000087100: 'Pediatric nurse practitioner (occupation)',
    26071000087103: 'PHCNP - primary health care nurse practitioner',
    26091000087104: 'Public health nurse practitioner',
    450044741000087104: 'Acupuncturist (occupation)',
    224930009: 'Services',
    224891009: 'Healthcare services',
    278032008: 'Preventive service',
    310000008: 'Casualty service',
    310001007: 'Anaesthetic service',
    310002000: 'Assessment service',
    310003005: 'Child assessment service',
    310004004: 'Audiological service',
    310005003: 'Diagnostic audiology service',
    310006002: 'Adult diagnostic audiology service',
    310007006: 'Paediatric diagnostic audiology service',
    310008001: 'Audiological screening service',
    310009009: 'Neonatal audiological screening service',
    310010004: 'Distraction test audiological screening service',
    310011000: 'Aural rehabilitation service',
    310012007: 'Cochlear implant service',
    310013002: 'Adult cochlear implant service',
    310014008: 'Paediatric cochlear implant service',
    310015009: 'Hearing aid service',
    310016005: 'Adult hearing aid service',
    310017001: 'Paediatric hearing aid service',
    310018006: 'Speech-reading training service',
    310019003: 'Tinnitus management service',
    310020009: 'Hearing therapy service',
    310021008: 'Assistive listening device service',
    310022001: 'Clinical oncology service',
    310023006: 'Radiotherapy service',
    310024000: 'Colposcopy service',
    310025004: 'Complementary therapy service',
    310026003: 'Counselling service',
    310027007: 'Mental health counselling service',
    310028002: 'Diagnostic investigation service',
    310029005: 'Domiciliary visit service',
    310030000: 'Endoscopy service',
    310031001: 'Family planning service',
    310032008: 'Intensive care service',
    310033003: 'Adult ITU service',
    310034009: 'Pediatric ITU service',
    310060005: 'Obstetrics and gynecology service',
    310061009: 'Gynaecology service',
    310062002: 'Pregnancy termination service',
    310063007: 'Obstetrics service',
    310064001: 'Occupational health service',
    310065000: 'Open access service',
    310066004: 'Paediatric service',
    310067008: 'Community pediatric service',
    310068003: 'Paediatric neurology service',
    310069006: 'Pediatric oncology service',
    310070007: 'Special care baby service',
    310071006: 'Pain management service',
    310072004: 'Acute pain service',
    310073009: 'Palliative care service',
    310074003: 'Pathology service',
    310076001: 'Clinical biochemistry service',
    310078000: 'Medical microbiology service',
    310079008: 'Neuropathology service',
    310080006: 'Pharmacy service',
    310081005: 'Professional allied to medicine service',
    310082003: 'Arts therapy services',
    310083008: 'Art therapy service',
    310084002: 'Dance therapy service',
    310085001: 'Drama therapy service',
    310086000: 'Music therapy service',
    310087009: 'Podiatry service',
    310088004: 'Community podiatry service',
    310089007: 'Hospital-based podiatry service',
    310090003: 'Dietetics service',
    310091004: 'Community-based dietetics service',
    310092006: 'Hospital dietetics service',
    310093001: 'Occupational therapy service',
    310094007: 'Community-based occupational therapy service',
    310095008: 'Social services occupational therapy service',
    310096009: 'Hospital occupational therapy service',
    310098005: 'Hospital physiotherapy service',
    310099002: 'Child physiotherapy service',
    310100005: 'Play therapy service',
    310101009: 'Speech and language therapy service',
    310102002: 'Community-based speech and language therapy service',
    310103007: 'Hospital speech and language therapy service',
    310104001: 'Child speech and language therapy service',
    310105000: 'Optometry service',
    310106004: 'Orthoptics service',
    310107008: 'Hospital orthoptics service',
    310108003: 'Community orthoptics service',
    310109006: 'Orthotics service',
    310110001: 'Hospital orthotics service',
    310111002: 'Community orthotics service',
    310112009: 'Surgical fitting service',
    310113004: 'Hospital surgical fitting service',
    310114005: 'Community surgical fitting service',
    310115006: 'Public health service',
    310116007: 'Psychiatry service',
    310117003: 'Child and adolescent psychiatry service',
    310118008: 'Forensic psychiatry service',
    310119000: 'Liaison psychiatry service',
    310121005: 'Psychogeriatric service',
    310122003: 'Rehabilitation psychiatry service',
    310123008: 'Psychology service',
    310124002: 'Psychotherapy service',
    310125001: 'Radiology service',
    310126000: 'Breast screening service',
    310127009: 'Magnetic resonance imaging service',
    310128004: 'Computerized tomography service',
    310129007: 'Rehabilitation service',
    310130002: 'Head injury rehabilitation service',
    310131003: 'Community rehabilitation service',
    310132005: 'Young disabled service',
    310133000: 'Swallow clinic',
    310134006: 'Social services',
    310135007: 'SSD customer services',
    310136008: 'Social services department duty team',
    310137004: 'Stroke service',
    310138009: 'Surgical service',
    310139001: 'Breast surgery service',
    310140004: 'Cardiothoracic surgery service',
    310141000: 'Thoracic surgery service',
    310142007: 'Cardiac surgery service',
    310143002: 'Dental surgery service',
    310144008: 'General dental surgery service',
    310145009: 'Oral surgery service',
    310146005: 'Orthodontics service',
    310147001: 'Paediatric dentistry service',
    310148006: 'Restorative dentistry service',
    310149003: 'Ear, nose and throat service',
    310150003: 'Endocrine surgery service',
    310151004: 'Gastrointestinal surgery service',
    310152006: 'General GI surgery service',
    310153001: 'Upper gastrointestinal surgery service',
    310155008: 'Colorectal surgery service',
    310156009: 'General surgical service',
    310157000: 'Hand surgery service',
    310158005: 'Hepatobiliary surgical service',
    310159002: 'Neurosurgical service',
    310160007: 'Ophthalmology service',
    310161006: 'Orthopaedic service',
    310162004: 'Pancreatic surgery service',
    310163009: 'Paediatric surgical service',
    310164003: 'Plastic surgery service',
    310165002: 'Transplant surgery service',
    310166001: 'Trauma surgery service',
    310167005: 'Urology service',
    310168000: 'Vascular surgery service',
    310169008: 'Ultrasonography service',
    310200001: 'Cytology service',
    373654008: 'Medical referral service (qualifier value)',
    395086005: 'Community specialist palliative care (qualifier value)',
    395104009:
      'Cancer primary healthcare multidisciplinary team (qualifier value)',
    408451000: 'Community learning disabilities team (qualifier value)',
    408452007: 'Behavioural intervention team',
    408458006: 'Specialist multidisciplinary team (qualifier value)',
    409971007: 'Emergency medical services (qualifier value)',
    413294000: 'Community health services (qualifier value)',
    413299005: 'Early years services (qualifier value)',
    413331009: 'Voluntary services (qualifier value)',
    444913002: 'Diabetes mellitus service (qualifier value)',
    444933003: 'Home hospice service (qualifier value)',
    445449000: 'Acute care hospice service (qualifier value)',
    699478002: 'Surgical oncology service (qualifier value)',
    699650006: 'Community based physiotherapy service (qualifier value)',
    700221004: 'Care of elderly service',
    700231006: 'Critical care physician service (qualifier value)',
    700232004: 'General medical service',
    700241009: 'Dermatology service (qualifier value)',
    700433006: 'Gastroenterology service',
    700434000: 'Endocrinology service (qualifier value)',
    700435004: 'Clinical physiology service',
    700436003: 'Clinical pharmacology service (qualifier value)',
    705150003: 'Domiciliary physiotherapy service (qualifier value)',
    706900000: 'Parasitology service',
    706901001: 'Bacteriology service',
    706902008: 'Mycology service (qualifier value)',
    706903003: 'Mycobacteriology service (qualifier value)',
    708168004: 'Mental health service',
    708169007: 'Respiratory therapy service (qualifier value)',
    708170008: 'Nursing service',
    708171007: 'Vascular ultrasound service',
    708172000: 'Cardiac ultrasound service (qualifier value)',
    708173005: 'Obstetric ultrasound service (qualifier value)',
    708174004: 'Interventional radiology service (qualifier value)',
    708175003: 'Diagnostic imaging service (qualifier value)',
    708178001: 'Cytogenetics service (qualifier value)',
    708179009: 'Molecular pathology service',
    708180007: 'Dermatopathology service',
    708182004: 'Histology service (qualifier value)',
    708183009: 'Anatomic pathology service (qualifier value)',
    708184003: 'Clinical pathology service (qualifier value)',
    708185002: 'Virology service',
    708187005: 'Surgical pathology service (qualifier value)',
    708188000: 'Serology service (qualifier value)',
    708190004: 'Immunology service',
    708191000: 'Toxicology service',
    708193002: 'Coagulation service',
    708194008: 'Blood bank service',
    708196005: 'Hematology service (qualifier value)',
    710028007: 'Maxillofacial surgery service',
    711332004: 'Allergy service',
    714088003: 'Midwifery service (qualifier value)',
    714089006: 'Community midwifery service (qualifier value)',
    722140001: 'Physiotherapy service (qualifier value)',
    722170006: 'Chiropractic service (qualifier value)',
    722174002: 'Pulmonary medicine service (qualifier value)',
    722175001: 'Psychosomatic medicine service (qualifier value)',
    722176000: 'Dentistry service (qualifier value)',
    722352000: 'Vascular medicine service (qualifier value)',
    722393008: 'Legal medicine service (qualifier value)',
    722424008: 'Physical medicine and rehabilitation service (qualifier value)',
    733459009: 'Cardiac rehabilitation service (qualifier value)',
    733921009: 'Transplant medicine service (qualifier value)',
    734862008: 'Endodontic service (qualifier value)',
    734863003: 'Prosthodontic service (qualifier value)',
    734920002: 'Diabetes mellitus education service (qualifier value)',
    736622005: 'Aboriginal health service (qualifier value)',
    741073001: 'Neonatal intensive care service (qualifier value)',
    773558007: 'Physical medicine service (qualifier value)',
    788001008: 'Infectious disease service (qualifier value)',
    788002001: 'Adult mental health service (qualifier value)',
    788003006: 'Nephrology service',
    788004000: 'Clinical genetics service (qualifier value)',
    788005004: 'Neurology service',
    788006003: 'Genetic laboratory service',
    788007007: 'General practice service',
    788008002: 'Oral and maxillofacial surgery service',
    788009005: 'Nuclear medicine service',
    788121006: 'Clinical immunology and allergy service',
    788122004: 'Sexual health service',
    788123009: 'Radiation oncology service (qualifier value)',
    788124003: 'Histopathology service (qualifier value)',
    788125002: 'Addiction service',
    788126001: 'Prosthetic service',
    788127005: 'Child health service',
    788128000: 'Critical care medicine service',
    789714005: 'Pediatric rheumatology service (qualifier value)',
    789715006: 'Paediatric respiratory therapy service',
    789716007: 'Pediatric otolaryngology service',
    789717003: 'Paediatric cardiology service',
    789718008: 'Cardiology service (qualifier value)',
    792847005: 'Emergency ambulance service (qualifier value)',
    792848000: 'Internal medicine service',
    792849008: 'Pediatric clinical genetics service',
    816075004: 'Prosthetic and orthotic service',
    830037002: 'Clinical immunology service',
    830038007: 'Clinical allergy service',
    830039004: 'Genitourinary medicine service (qualifier value)',
    830149003: 'Clinical neurophysiology service',
    840585009: 'Postpartum service',
    840586005: 'Neonatal service',
    840587001: 'Aerospace medical service',
    896974005: 'Transgender health service (qualifier value)',
    897188002: 'Pediatric hematology service',
    1148679005: 'Specialist palliative care service',
    1163002007: 'Electrocardiography service (qualifier value)',
    1163003002: 'Colorectal cancer screening service',
    1163004008: 'Hyperbaric medicine service (qualifier value)',
    1163054002: 'Gastroscopy service (qualifier value)',
    1186717003: 'Intellectual disability psychiatry service',
    1230044005: 'Cardiac specialist nurse service',
    1230045006: 'Cardiac diagnostic service (qualifier value)',
    1230046007: 'Cervical cancer screening service',
    1231390004: 'Hand therapy service',
    1231391000: 'Colonoscopy service (qualifier value)',
    1231392007: 'Paediatric orthopaedic service',
    1231393002: 'Spirometry service',
    1231394008: 'Paediatric urology service',
    1231786003: 'Refugee healthcare service (qualifier value)',
    1234796008: 'Community nursing service',
    1237575008: 'Stomatology service',
    1240399006: 'Telehealth service (qualifier value)',
    1255186006: 'Periodontic service (qualifier value)',
    1255633009: 'Neuroradiology service (qualifier value)',
    1255878009: 'Cardiac electrophysiology service (qualifier value)',
    1255914002: 'Burns service',
    1256098007: 'Home hospitalization (qualifier value)',
    1259941004: 'Alcohol treatment service',
    2351000175106: 'Sports medicine service (qualifier value)',
    2391000175104: 'Bariatric surgery service (qualifier value)',
    2421000175108: 'Acute care inpatient service (qualifier value)',
    2451000175103: 'Perinatology service (qualifier value)',
    2461000175101: 'Pulmonary rehabilitation service (qualifier value)',
    2471000175109: 'Employee health service (qualifier value)',
    3531000175102: 'Geriatric service (qualifier value)',
    3621000175101: 'Rheumatology service',
    3751000175100: 'Pediatric emergency medical service (qualifier value)',
    3761000175103: 'Pediatric endocrinology service (qualifier value)',
    3771000175106: 'Pediatric gastroenterology service (qualifier value)',
    3781000175109: 'Pediatric infectious disease service (qualifier value)',
    3791000175107: 'Pediatric nephrology service (qualifier value)',
    3801000175108: 'Pediatric pulmonology service (qualifier value)',
    23871000087101: 'Adult dermatology service',
    23891000087102: 'Adult hematology service',
    23901000087101: 'Hepatology service',
    23911000087104: 'Medication review service (qualifier value)',
    23941000087103: 'Narcotic addiction service',
    23951000087100: 'Opioid dependence service',
    24001000087103: 'Paediatric plastic surgery service',
    24011000087101: 'Vascular imaging service (qualifier value)',
    24051000087102: 'Breast surgical oncology service (qualifier value)',
    24081000087105: 'Human immunodeficiency virus nurse practitioner service',
    24101000087102: 'HIV (human immunodeficiency virus) social work service',
    24141000087104: 'Spine orthopedic surgery service (qualifier value)',
    24271000087103: 'Adult chronic pain management service (qualifier value)',
    24291000087104: 'Geriatric chronic pain management service',
    24331000087108: 'Narcotic addiction service with chronic pain management',
    24351000087104: 'Paediatric chronic pain management service',
    28541000087101: 'Musculoskeletal service',
    34911000087100: 'Amputation care service (qualifier value)',
    431051000124102: 'Dialysis service (qualifier value)',
    1136421000168109: 'Sleep medicine service',
  })
);

export const CARE_TEAM_ORG_TYPE_MAP = new Map(
  Object.entries({
    crs: 'Clinical Research Sponsor',
    cg: 'Community Group',
    edu: 'Educational Institute',
    govt: 'Government',
    prov: 'Healthcare Provider',
    dept: 'Hospital Department',
    ins: 'Insurance Company',
    bus: 'Non-Healthcare Business or Corporation',
    team: 'Organizational team',
    pay: 'Payer',
    reli: 'Religious Institution',
    other: 'Other',
  })
);

export const NAME_PREFIXES = ['Mr.', 'Ms.', 'Mrs.', 'Sr.', 'Dr.'];
